import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {SharedModule} from '@app/shared';
import {UnitRegisterComponent} from '@app/unit/register/unit-register.component';
import {unitRegisterRouter} from '@app/unit/unit-register.route';
const ENTITY_STATES = [...unitRegisterRouter];

@NgModule({
  declarations: [UnitRegisterComponent],
  imports: [SharedModule, RouterModule.forChild(ENTITY_STATES as Routes)],
  entryComponents: [UnitRegisterComponent],
})
export class UnitRegisterModule {}
